<template>
  <div class="mine">
    <div class="bannerWrap">
      <div class="userInfo">
        <div class="iconWrap">
          <img v-if="userInfo.avatar" :src="userInfo.avatar" style="width: 70px; height: 70px; border-radius: 50%" />
          <img v-else src="/img/newPages/touxiang.png" style="width: 70px; height: 70px; border-radius: 50%" />
        </div>
        <h5>{{ $store.state.name || userInfo.name || '用户' }}</h5>
        <p v-if="remainingTime">超级VIP会员 {{ remainingTime }}</p>
        <p v-else>普通用户</p>
        <div class="user_btn" @click="switchTab(1)">
          <span>{{ remainingTime ? '立即续费' : '开通会员' }}</span>
        </div>
        <div class="quitSty" @click="logout">
          <img src="/img/quit.png" alt="" />
          <span>退出</span>
        </div>
      </div>
      <img src="/img/banner_bg.4770d74d.png" alt="" />
    </div>
    <div class="baseMain baseWrap">
      <ul class="asideMenu">
        <li :class="{ tabActive: currentTab === 0 }" @click="switchTab(0)">
          <img :src="currentTab === 0 ? '/img/mine_0_active.28e97fc0.png' : '/img/mine_0.3d12bf02.png'" />
          个人设置
        </li>
        <li :class="{ tabActive: currentTab === 1 }" @click="switchTab(1)">
          <img :src="currentTab === 1 ? '/img/mine_1_active.52d46ffe.png' : '/img/mine_1.af518227.png'" />
          VIP管理
        </li>
        <li :class="{ tabActive: currentTab === 2 }" @click="switchTab(2)">
          <img :src="currentTab === 2 ? '/img/mine_2_active.ac38b4fa.png' : '/img/mine_2.09df8748.png'" />
          订单管理
        </li>
        <li :class="{ tabActive: currentTab === 3 }" @click="switchTab(3)">
          <img :src="currentTab === 3 ? '/img/mine_3_active.50e03790.png' : '/img/mine_3.22c51f62.png'" />
          我的消息
        </li>
        <li :class="{ tabActive: currentTab === 4 }" @click="switchTab(4)">
          <img :src="currentTab === 4 ? '/img/mine_4_active.964c5905.png' : '/img/mine_4.f216e435.png'" />
          观看历史
        </li>
        <li :class="{ tabActive: currentTab === 5 }" @click="switchTab(5)">
          <img :src="currentTab === 5 ? '/img/mine_5_active.1daff78c.png' : '/img/mine_5.4faae0c2.png'" />
          收藏历史
        </li>
        <li :class="{ tabActive: currentTab === 6 }" @click="switchTab(6)">
          <img :src="currentTab === 6 ? '/img/mine_6_active.a0bd13d8.png' : '/img/mine_6.332c0469.png'" />
          下载历史
        </li>
      </ul>
      <div class="contentArea">
        <PersonalSettings v-if="currentTab === 0" :user-info="userInfo" @refresh="getUserInfo" />
        <VipManagement v-if="currentTab === 1" />
        <OrderManagement v-if="currentTab === 2" />
        <MyMessage v-if="currentTab === 3" />
        <HistoryList v-if="currentTab === 4" type="watch" />
        <HistoryList v-if="currentTab === 5" type="collect" />
        <HistoryList v-if="currentTab === 6" type="download" />
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getUser, removeToken, removeUser } from '@/utils/auth'
import PersonalSettings from './PersonalSettings.vue'
import VipManagement from './VipManagement.vue'
import OrderManagement from './OrderManagement.vue'
import MyMessage from './MyMessage.vue'
import HistoryList from './HistoryList.vue'

export default {
  name: 'Mine',
  components: { PersonalSettings, VipManagement, OrderManagement, MyMessage, HistoryList },
  data() {
    return {
      currentTab: 0,
      userInfo: {},
      remainingTime: ''
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    switchTab(index) {
      this.currentTab = index
    },
    getUserInfo() {
      const user = getUser()
      if (user) {
        this.userInfo = typeof user === 'string' ? JSON.parse(user) : user
        this.$store.state.avatar = this.userInfo.avatar
      }
    },
    logout() {
      removeToken()
      removeUser()
      this.$store.commit('clearUserInfo')
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.mine {
  width: 100%;
}

.bannerWrap {
  width: 100%;
  height: 240px;
  position: relative;
  z-index: 2;

  > img {
    width: 100%;
    height: 240px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .userInfo {
    width: 860px;
    height: 100%;
    padding: 20px 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    position: relative;
    font-size: 14px;
    z-index: 2;
    box-sizing: border-box;

    .iconWrap {
      width: 70px;
      height: 70px;
      background-color: #d2e0e2;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
    }

    h5 {
      font-size: 18px;
    }

    .user_btn {
      width: 120px;
      height: 38px;
      background: linear-gradient(-90deg, rgba(249, 194, 107, 0.7), rgba(255, 226, 158, 0.7));
      border-radius: 19px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        color: #473824;
        font-size: 16px;
        font-weight: 700;
      }
    }

    .quitSty {
      width: 60px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}

.baseMain {
  padding: 20px 0;
  background-color: #fff;
  display: flex;
}

.asideMenu {
  width: 230px;
  height: 340px;
  padding: 25px 0;
  margin-right: 30px;
  background-color: #f3f7f8;
  list-style: none;
  box-sizing: border-box;
  flex-shrink: 0;

  li {
    width: 100%;
    height: 40px;
    padding: 0 60px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: #000;
    cursor: pointer;
    white-space: nowrap;

    img {
      width: 20px;
      height: 20px;
      margin-right: 16px;
    }
  }

  .tabActive {
    background: #3bc0d0;
    color: #fff;
  }
}

.contentArea {
  flex: 1;
  padding: 20px;
}
</style>
